import React from 'react'

const notFound = () => {
  return (
    <div style={{height: '100vh'}}>Page not found</div>
  )
}

export default notFound